import * as yup from "yup";
import { FuncionamientoSchema } from "./FuncionamientoSchema";
import { PuntoGeograficoSchema } from "./PuntoGeograficoSchema";
import { CantidadSchema } from "./CantidadSchema";
import { MedicionCaudalMasicoSchema } from "./MedicionCaudalMasicoSchema";

export const DuctoSchema = yup.object().shape({
  orden: yup.number().required("errors.ducto.orden.required"),
  numeroDucto: yup
    .string()
    .max(20, "errors.ducto.numeroDucto.max")
    .required("errors.ducto.numeroDucto.required")
    .default(""),
  referencia: yup
    .string()
    .max(150)
    .required("errors.ducto.referencia.required")
    .default(""),
  operacionesUnitarias: yup
    .array()
    .min(1, "errors.ducto.operacionesUnitarias.min")
    .required("errors.ducto.operacionesUnitarias.required")
    .default([]),
  funcionamientoContinuo: yup
    .boolean()
    .required("errors.ducto.funcionamientoContinuo.required")
    .default(false),
  funcionamiento: yup
    .object()
    .concat(FuncionamientoSchema)
    .required("errors.ducto.funcionamiento.required")
    .default(FuncionamientoSchema.cast(undefined, { assert: false })),
  ubicacion: yup
    .object()
    .concat(PuntoGeograficoSchema)
    .required("errors.ducto.ubicacion.required")
    .default(PuntoGeograficoSchema.cast(undefined, { assert: false })),
  seccion: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.ducto.seccion.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M2" } }),
  altura: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.ducto.altura.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M" } }),
  diametro: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.ducto.diametro.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M" } }),
  temperatura: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.ducto.temperatura.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "K" } }),
  velocidadSalida: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.ducto.velocidad.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "MGS" } }),
  caudal: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.ducto.caudal.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M3H" } }),
  caudalMasico: yup
    .array()
    .of(MedicionCaudalMasicoSchema)
    .min(1, "errors.ducto.caudalMasico.min")
    .required("errors.ducto.caudalMasico.required")
    .default([]),
  descripcionTratamiento: yup
    .string()
    .max(1024, "errors.ducto.descripcionTratamiento.max")
    .optional()
    .nullable()
    .default(null),
  tratamiento: yup.object().optional().nullable().default(null),
});
